<medrecord-auth-qr-code [otpUri]="otpUri$ | async"></medrecord-auth-qr-code>